export const LinksData = [
  {
    key: "ActivityPub(misskey / mastodon)",
    detail: [
      {
        a: "ruste.red:misskey : @liddle@misskey.ruste.red",
        link: "https://misskey.ruste.red/@liddle",
      },
      {
        a: "misskey.io : @RusteredML@misskey.io",
        link: "https://misskey.io/@rusteredML",
      },
      {
        a: "VTdon : @LiddleBRM@vtdon.com",
        link: "https://vtdon.com/@LiddleBRM",
      },
    ],
  },
  {
    key: "twitter",
    detail: [
      { a: "twitter: @LiddleBRM", link: "https://twitter.com/LiddleBRM" },
    ],
  },
  {
    key: "blog",
    detail: [{ a: "blog", link: "https://blog.ruste.red" }],
  },
  {
    key: "YouTube",
    detail: [
      { a: "YouTube: @LiddleBRM", link: "https://www.youtube.com/@LiddleBRM" },
    ],
  },
  {
    key: "twitch",
    detail: [
      {
        a: "twitch: liddlebrmarshall",
        link: "https://www.twitch.tv/liddlebrmarshall",
      },
    ],
  },
  /*
  {
    key: "IRIAM",
    detail: [
      {
        a: "Julia Rustered Scott",
        link: "https://web.iriam.app/s/user/0HoX43pDWg?uuid=34ab3420",
      },
    ],
  },
  */
  {
    key: "keybase",
    detail: [
      {
        a: "keybase: liddlebrmarshall",
        link: "https://keybase.io/liddlebrmarshall",
      },
    ],
  },
  {
    key: "Github",
    detail: [
      {
        a: "Github: LiddleBRM",
        link: "https://github.com/LiddleBRM",
      },
    ],
  },
  {
    key: "Geartics",
    detail: [
      {
        a: "Geartics: The Rustered",
        link: "https://www.geartics.com/Y1mwOZTIF",
      },
    ],
  },
];
